import React from "react";
import { Skeleton } from "@mui/material";
import Grid from '@mui/material/Grid2';
import Container from "@mui/material/Container";

const OrgDashSkeleton = () => {
    const gridItems = Array.from({ length: 10 });

    return (
        <>
            <Grid container spacing={5} justify="center" style={{marginBottom:20}}>
                <Grid item size={12}>
                    <Skeleton
                        variant="rectangular"
                        width="100%"
                        height={310}
                        animation="wave"
                        style={{borderRadius:16,marginBottom:10}}
                    />
                </Grid>
            </Grid>
            <Container maxWidth="xl">
                <Grid container spacing={5} justify="center">
                    <Grid item size={{xs:12,lg:9}}>
                        <Grid container spacing={2} justify="center">
                            {gridItems.map((_, index) => (
                                <Grid item size={{xs:12,sm:6}}>
                                    <Skeleton
                                        variant="rectangular"
                                        width="100%"
                                        height={150}
                                        animation="wave"
                                        style={{borderRadius:16,marginBottom:10}}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                    {/*<Grid item size={{xs:12,lg:3}}>
                        <Grid container spacing={2} justify="center">
                            <Grid item size={{xs:12}}>
                                <Skeleton
                                    variant="rectangular"
                                    width="100%"
                                    height={100}
                                    animation="wave"
                                    style={{borderRadius:16,marginBottom:10}}
                                />
                            </Grid>
                            <Grid item size={{xs:12}}>
                                <Skeleton
                                    variant="rectangular"
                                    width="100%"
                                    height={100}
                                    animation="wave"
                                    style={{borderRadius:16,marginBottom:10}}
                                />
                            </Grid>
                            <Grid item size={{xs:12}}>
                                <Skeleton
                                    variant="rectangular"
                                    width="100%"
                                    height={100}
                                    animation="wave"
                                    style={{borderRadius:16,marginBottom:10}}
                                />
                            </Grid>

                            <Grid item size={{xs:12}}>
                                <Skeleton
                                    variant="rectangular"
                                    width="100%"
                                    height={60}
                                    animation="wave"
                                    style={{borderRadius:16,marginBottom:10}}
                                />
                            </Grid>
                        </Grid>
                    </Grid>*/}
                </Grid>
            </Container>
        </>
    );
};

export default OrgDashSkeleton;
